import { toJpeg, toPng } from 'html-to-image';
import { resolvePageFormat, slideSize } from '../types';

async function waitForImages(root: HTMLElement): Promise<void> {
  const images = Array.from(root.querySelectorAll('img'));
  await Promise.all(images.map((image) => (
    image.complete
      ? Promise.resolve()
      : new Promise<void>((resolve) => {
        image.onload = () => resolve();
        image.onerror = () => resolve();
      })
  )));
}

export async function captureSlideNode(
  node: HTMLElement,
  background = '#FFFFFF',
  pageFormat?: string | null,
): Promise<string> {
  await document.fonts.ready;
  await waitForImages(node);
  await new Promise<void>((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
  });
  const size = slideSize(pageFormat);
  const options = {
    width: size.width,
    height: size.height,
    pixelRatio: size.exportWidth / size.width,
    backgroundColor: background,
    cacheBust: true,
  };
  if (resolvePageFormat(pageFormat) === 'a4_portrait') {
    return toJpeg(node, { ...options, quality: 0.92 });
  }
  return toPng(node, options);
}
